// extracted by css-extract-rspack-plugin
export default {"area":"f19NPdUpzXgCjTNe"};